var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  "data-name": "Layer 1",
  viewBox: "0 0 64 64"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M56.51,8.49,20.66,44.34,7.49,31.16a1.63,1.63,0,0,0-2.31,0L1.32,35a1.63,1.63,0,0,0,0,2.31L19.51,55.51a1.63,1.63,0,0,0,2.31,0L62.68,14.65a1.63,1.63,0,0,0,0-2.31L58.82,8.49A1.63,1.63,0,0,0,56.51,8.49Z"
})));
export default __webpack_public_path__ + "static/media/check.fb26a39b.svg";
export { SvgComponent as ReactComponent };